import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    position: 'relative',
    [theme.breakpoints.up('md')]: {
      marginBottom: ({ bottomMargin }) => `${bottomMargin}px`,
    },
  },
  imageContainer: ({ images }) => ({
    backgroundImage: images && `url(${images.lg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    width: '100%',
    height: '70vh',
    [theme.breakpoints.down('xs')]: {
      height: '60vh',
      backgroundImage: images && `url(${images.sm})`,
    },
  }),
  videoContainer: {
    objectFit: 'cover',
    width: '100%',
    height: '70vh',
    position: 'relative',
    [theme.breakpoints.down('xs')]: {
      height: '60vh',
    },
  },
  buttonContainer: {
    position: 'absolute',
    left: '35px',
    bottom: '20px',
    display: 'flex',
    '&>button:nth-child(1)': {
      marginRight: theme.spacing(1),
      paddingLeft: '10px',
    },
    [theme.breakpoints.down('sm')]: {
      left: 'auto',
      bottom: '330px',
      right: '16px',
    },
  },
  videoButton: {
    backgroundColor: theme.palette.secondary.dark,
    padding: '10px',
    paddingLeft: '15px',
    height: '42px',
    width: '42px',
    border: 'none',
    '&:focus': {
      outline: '3px solid white',
    },
    '&:hover': {
      cursor: 'pointer',
    },
  },
  ctaContainer: {
    [theme.breakpoints.up('md')]: {
      position: 'absolute',
      bottom: ({ offset }) => `${offset}px`,
      left: 0,
      right: 0,
      display: 'flex',
      justifyContent: 'flex-end',
    },
  },
}))
